<div class="aprova-stepper" [ngClass]="'stepper-' + type">
  <ng-container *ngIf="type === 'simple'">
    <div class="stepper-line">
      <div
        *ngFor="let stepIndex of stepNumbers; let isLast = last"
        class="step-segment"
        [class.active]="isStepActive(stepIndex)"
        [class.completed]="isStepCompleted(stepIndex)"
        [class.enabled]="isStepEnabled(stepIndex)"
        [class.clickable]="allowDirectNavigation && isStepEnabled(stepIndex)"
        (click)="onStepClick(stepIndex)"
      >
        <div class="segment-fill"></div>
      </div>
    </div>

    <div class="step-labels" *ngIf="showStepLabels && hasStepLabels()">
      <div
        *ngFor="let stepIndex of stepNumbers; trackBy: trackByStepIndex"
        class="step-label"
        [class.active]="isStepActive(stepIndex)"
        [class.completed]="isStepCompleted(stepIndex)"
        [class.enabled]="isStepEnabled(stepIndex)"
      >
        <div class="step-label-number">Passo {{ stepIndex + 1 }}</div>
        <div class="step-label-title" *ngIf="getStepConfig(stepIndex)?.title">
          {{ getStepConfig(stepIndex)?.title }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'bullets'">
    <div class="stepper-container">
      <!-- Progress bar spans full container width (extends beyond first/last bullets) -->
      <div class="progress-bar">
        <div class="progress-fill" [style.width]="getProgressWidth()"></div>
      </div>

      <div class="steps-row">
        <!-- Steps -->
        <div
          *ngFor="let stepIndex of stepNumbers; let isLast = last"
          class="step-bullet"
          [class.active]="isStepActive(stepIndex)"
          [class.completed]="isStepCompleted(stepIndex)"
          [class.enabled]="isStepEnabled(stepIndex)"
          [class.clickable]="allowDirectNavigation && isStepEnabled(stepIndex)"
          (click)="onStepClick(stepIndex)"
        >
          <div class="bullet-content">
            <span class="step-number">{{ stepIndex + 1 }}</span>
          </div>

          <div class="step-title" *ngIf="showStepLabels && getStepConfig(stepIndex)?.title">
            {{ getStepConfig(stepIndex)?.title }}
          </div>
        </div>
      </div><!-- steps-row -->
    </div><!-- stepper-container -->
  </ng-container>

  <div class="stepper-content">
    <ng-container *ngFor="let stepIndex of stepNumbers">
      <div *ngIf="isStepActive(stepIndex)" class="step-content" [attr.data-step]="stepIndex">
        <ng-container
          *ngIf="hasStepTemplate(stepIndex)"
          [ngTemplateOutlet]="getStepTemplate(stepIndex)"
          [ngTemplateOutletContext]="{
            stepIndex: stepIndex,
            step: getStepConfig(stepIndex),
            isActive: isStepActive(stepIndex),
            isCompleted: isStepCompleted(stepIndex),
            isEnabled: isStepEnabled(stepIndex)
          }"
        ></ng-container>
      </div>
    </ng-container>
  </div>

  <ng-content select="[slot=step-content]"></ng-content>
</div>
